var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"wx-alert-message",class:[_vm.containerCssClass, _vm.type, { bordered: _vm.bordered }, { 'wx-alert-message--no-query-results': _vm.noResultsIcon }],attrs:{"icon":_vm.noResultsIcon ? 'mdi-circle-off-outline' : null}},[_c('p',{staticClass:"mb-0",class:_vm.textCssClass},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }